import {
	ConsultancyLogo,
	EventsLogo,
	TracsisRailTechServicesLogo,
	MPECLogo,
	RailOpsLogo,
	TrafficDataLogo,
	USLogo,
} from '@tracsis/library/src';
import { ArrowRight } from '@tracsis/library/src/components/Icon';
import React, { useEffect, useState } from 'react';

import * as styles from './NewsBanner.module.css';

const NewsBanner = ({
	canonicalSite,
}: {
	canonicalSite: { label: string; tag: string; to: string; uuid: string };
}) => {
	const { label, to, uuid } = canonicalSite;
	const [logo, setLogo] = useState<JSX.Element | null>(null);

	useEffect(() => {
		setLogo(() => {
			if (uuid === 'a592c9d8-7829-4322-876a-920c3c564286')
				return <RailOpsLogo />;

			if (uuid === '23f199a2-eb34-436d-90e4-9c296c5742b3')
				return <TracsisRailTechServicesLogo />;

			if (uuid === '16d325d7-5ce6-4a5f-b540-fd12af03ea47') return <MPECLogo />;

			if (uuid === 'e2605939-3e58-4311-841e-b4828550ab8b')
				return <USLogo />;

			if (uuid === 'e486c3a3-4c39-477f-9751-6630f4573907')
				return <TrafficDataLogo />;

			if (uuid === '92adc2cc-17f9-4383-af83-e0badb65cac7') return <EventsLogo />;

			if (uuid === '8a951812-95c2-42b3-9ee4-e308225585a8')
				return <ConsultancyLogo />;

			return null;
		});

		return () => {
			setLogo(null);
		};
	}, []);

	return (
		<div className={styles.banner}>
			<figure className={styles.logo}>{logo && logo}</figure>

			<a
				href={`${to}/news`}
				target="_blank"
				rel="noopener noreferrer"
				className={styles.link}
			>
				See all {label} news <ArrowRight className={styles.arrow} />
			</a>
		</div>
	);
};

export default NewsBanner;
